import { Pagination } from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useAdminAllOrganizations } from '../../../api/organization';
import AdminOrganizationTable from '../../eventProvider/AdminOrganizationTable';
import AdminCommonBG from '../AdminCommonBG';
import { HeaderButton } from '../UIelements/AdminNavigation';
import Filter from '../UIelements/Filter';
import { organizationSorter } from '../UIelements/Sorter';

interface AdminOrganizationViewProps {
  create?: boolean;
}

const AdminOrganizationView: React.FC<AdminOrganizationViewProps> = props => {
  const navigate = useNavigate();

  const [pageCursor, setPageCursor] = React.useState<number>(0);
  const pageSize = 10;
  const [organizationDataList] = useAdminAllOrganizations();

  const onAdminEdit = (eventId?: string) => {
    navigate(`/admin/events/${eventId}/edit`);
  };
  const onAdminControl = (eventId?: string) => {
    navigate(`/admin/events/${eventId}/control`);
  };
  const onCreateOrg = (orgId?: string) => {
    navigate(`/admin/organization/create`);
  };

  const [sortKey, setSortKey] = React.useState({
    key: 'name',
    sort: 'ASC',
  });

  const onChangeSort = (sortObj: any) => {
    setSortKey(sortObj);
  };

  const btnAdd: HeaderButton = {
    buttonText: '＋企業の追加',
    event: onCreateOrg,
  };

  const [filter, setFilter] = React.useState<{
    org_name?: string;
  }>({});
  const sorter = organizationSorter[sortKey.key][sortKey.sort];
  const filteredOrganizationList = React.useMemo(() => {
    return (organizationDataList ?? [])
      .sort(sorter)
      .filter(
        (e: { name: string | string[] }) =>
          !filter.org_name || e.name.indexOf(filter.org_name) !== -1
      );
  }, [organizationDataList, sorter, filter.org_name]);

  return (
    <AdminCommonBG title='企業' headerButtons={[btnAdd]}>
      <Filter
        item={[
          { type: 'input', name: 'org_name', label: '組織名', width: 300 },
        ]}
        onSend={params => {
          setFilter(params);
          setPageCursor(0);
        }}
      />
      <AdminOrganizationWrapper>
        <AdminOrganizationTable
          organizationDataList={filteredOrganizationList.filter(
            (_: any, i: number) => pageCursor <= i && i < pageCursor + pageSize
          )}
          onAdminEdit={onAdminEdit}
          onAdminControl={onAdminControl}
          sortObj={sortKey}
          onChangeSort={onChangeSort}
        />
      </AdminOrganizationWrapper>
      <Pagination
        count={filteredOrganizationList.length}
        begin={pageCursor}
        end={Math.min(pageCursor + pageSize, filteredOrganizationList.length)}
        onNext={() => {
          setPageCursor(pageCursor + pageSize);
        }}
        onPrev={() => {
          setPageCursor(Math.max(pageCursor - pageSize, 0));
        }}
      />
    </AdminCommonBG>
  );
};

const AdminOrganizationWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export default AdminOrganizationView;
